<div class="d-flex">
  <span class="snackbar-icon-wrapper" *ngIf="data.icon">
    <mat-icon [svgIcon]="data.icon"></mat-icon>
  </span>

  <div matSnackBarLabel [innerHTML]="data.message"></div>

  <button
    *ngIf="data.action"
    matSnackBarAction
    luiTextButton
    (click)="snackbar.dismiss()"
  >
    {{ data.action }}
  </button>
</div>
